document.addEventListener('DOMContentLoaded', function() {
  var opener = document.getElementById('OpenDetailsDrawer');
  var btnClose = document.getElementById('CloseDetailsDrawer');
  var overlay = document.getElementById('DetailsDrawerOverlay');
  var drawer = document.getElementById('DetailsDrawer');

  if (!drawer || !opener) {
    return;
  }

  function openDrawer() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('visible');
  }
  function closeDrawer() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('visible');
  }

  opener.addEventListener('click', openDrawer);
  
  if (btnClose) btnClose.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('click', function(e) {
    var clickedInsideDrawer = drawer && drawer.contains(e.target);
    var clickedOnOpener = opener && opener.contains(e.target);

    if (
      drawer &&
      drawer.classList.contains('open') &&
      !clickedInsideDrawer &&
      !clickedOnOpener
    ) {
      closeDrawer();
    }
  });
});